<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-data-table :items="[project]" class="elevation-1" hide-actions hide-headers>
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left subheading sm2">Project ID</td>
            <td class="text-xs-left subheading">{{ project.id }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Project Name</td>
            <td class="text-xs-left subheading">{{ project.name }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">UUID</td>
            <td class="text-xs-left subheading">{{ project.uuid }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Status</td>
            <td class="text-xs-left subheading">{{ project.status }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Date Created</td>
            <td class="text-xs-left subheading">{{ formatDateTime(project.dateAdded) }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Date Modified</td>
            <td class="text-xs-left subheading">{{ formatDateTime(project.dateModified) }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Date Archived</td>
            <td class="text-xs-left subheading">{{ formatDateTime(project.archiveDate) }}</td>
          </tr>
          <tr>
            <td class="text-xs-left subheading sm2">Config</td>
            <td class="text-xs-left subheading">
              <v-layout row v-for="(item, key) in project.config" :key=key>
                <v-flex sm4 subheading class="text-sm-left">{{key}}:</v-flex>
                <v-flex sm8 subheading class="text-sm-left" style="word-break: break-all;">{{item}}</v-flex>
              </v-layout>
            </td>
          </tr>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="error" icon="warning">No data available</v-alert>
        </template>
      </v-data-table>
      <v-layout justify-end mt-1>
        <v-btn class="mx-2" @click.native="$router.push('../')">Return</v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { getLocalDateTime } from '@/helpers/formatters'

export default {
  props: ['id'],
  computed: {
    ...mapGetters({
      getProjectById: 'getProjectById'
    }),
    project: function () {
      return (this.id && Number(this.id) > 0 && this.getProjectById(this.id) ? this.getProjectById(this.id) : {name: '', uuid: '', config: '', status: ''})
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    formatDateTime: function (date) {
      if (!date) {
        return ''
      }
      return getLocalDateTime(date)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/projects/ProjectDetails.vue